import React from 'react'
import { Grid } from '@mui/material'
import { useIsMobile } from 'utils/UI'
import Offer from '../Offer'
import { listingType } from '../utils'


const Offers = ({
  offers,
  offerOrigin = 'search',
  offerType = listingType.card,
  columns = 3,
  revalidateList,
  getOffer = (item) => item,
  getOfferKey = (item, offer) => offer.id,
  renderItem = (item, renderedOffer) => renderedOffer,
  getBeforeClaimAction = () => null,
}) => {
  const isCard = offerType === listingType.card
  const isMobile = useIsMobile()
  const isFavorites = offerOrigin === 'favorite'
  const usesAccountAvailabilityPresentation =
    isFavorites || offerOrigin === 'claimed'
  const allowUnavailableActions = usesAccountAvailabilityPresentation
  const grayOutUnavailable = !usesAccountAvailabilityPresentation

  return (
    <Grid
      alignItems="stretch"
      container
      direction={isCard ? 'row' : 'column'}
      justifyContent="center"
      spacing={2}
    >
      {
        offers.map((item) => {
          const offer = getOffer(item)
          const renderedOffer = (
            <Offer
              offer={offer}
              beforeClaimAction={getBeforeClaimAction(item)}
              offerOrigin={offerOrigin}
              offerType={isMobile ? listingType.card : offerType}
              revalidateList={revalidateList}
              allowUnavailableActions={allowUnavailableActions}
              grayOutUnavailable={grayOutUnavailable}
              showUnavailableLabels={usesAccountAvailabilityPresentation}
            />
          )
          return (
            <Grid key={getOfferKey(item, offer)} item xs={12} sm={6} md={isFavorites ? 6 : 4} lg={isCard ? columns : 12} style={{
              display: isCard ? 'flex' : 'block',
            }}>
              {renderItem(item, renderedOffer, isMobile ? listingType.card : offerType)}
            </Grid>
          )
        })
      }
    </Grid>
  )
}

export default Offers
